"use client";

import Link from "next/link";
import { NAV_ITEMS_DATA } from "../../consts";
import styles from "./index.module.scss";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

export default function NavbarList() {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);
  const isLang = /^[a-z]{2}$/i.test(segments[0]);
  const pathWithoutLang = isLang ? segments.slice(1) : segments;
  const currentPath = "/" + pathWithoutLang.join("/");

  const t = useTranslations("ProfileSideNav");

  return (
    <nav className={styles.navbar}>
      <ul className={styles.navbarList}>
        {NAV_ITEMS_DATA.map((item) => (
          <li
            key={item.href}
            className={`${styles.navbarItem} ${currentPath === item.href ? styles.navbarItem_active : ""}`}
          >
            <Link href={item.href} className={styles.navbarLink}>
              <div className={styles.navbarLinkContent}>
                <item.icon size={22} />
                <p className={styles.navbarLinkText}>{t(item.link)}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
